import * as React from 'react';
import styled from 'styled-components';
import { Size } from '../types';
import {COLORS} from '..';

export interface NotificationProps {
  size?: Size.Small | Size.Medium | Size.Large;
  variant: 'critical' | 'positive';
  testId?: string;
}

const ContentWrapper = styled.div<NotificationProps>`
  width: ${(props) => props.size === Size.Small ? '16px' : (props.size === Size.Large ? '24px' : '20px')};
  height: ${(props) => props.size === Size.Small ? '16px' : (props.size === Size.Large ? '24px' : '20px')};
  padding: ${(props) => props.size === Size.Small ? '3px' : (props.size === Size.Large ? '4px' : '4px')};
  box-sizing: border-box;
`;

const Content = styled.div<NotificationProps>`
  background-color: ${(props) => props.variant === 'positive' ? COLORS.correct_500 : COLORS.critical_500};
  height: ${(props) => props.size === Size.Small ? '10px' : (props.size === Size.Large ? '16px' : '12px')};
  width: ${(props) => props.size === Size.Small ? '10px' : (props.size === Size.Large ? '16px' : '12px')};
  border-radius: ${(props) => props.size === Size.Small ? '10px' : (props.size === Size.Large ? '16px' : '12px')};
  border: ${(props) => props.size === Size.Small ? '2px solid ' + COLORS.white : (props.size === Size.Large ? '3px solid ' + COLORS.white : '2px solid ' + COLORS.white)};
  box-sizing: border-box;
`;

const NotificationDot: React.FunctionComponent<NotificationProps> = ({size = Size.Medium, variant, testId}) => {
  return (
    <ContentWrapper size={size} variant={variant}>
      <Content size={size} variant={variant} data-testid={testId}/>
    </ContentWrapper>
  );
};

export default NotificationDot;
